import { FC } from 'react';

import Table from 'modules/_shared/Table';
import DividendsTableHeader from './DividendsTableHeader';
import DividendsTableBody from './DividendsTableBody';

const DividendsTable: FC = () => {
  const tableContent = (
    <>
      <DividendsTableHeader />
      <DividendsTableBody />
    </>
  );

  return <Table content={tableContent} scrollHorizontal />;
};

export default DividendsTable;
